import { Button, Form, Input } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useConfirmPasswordValidator } from '../../../hooks';
import { IFormProps } from '../../../typings';

export interface UpdatePasswordFormProps extends IFormProps {
  resendPasswordCode: () => Promise<void>;
  resendCodeLoading: boolean;
}

export function UpdatePasswordForm({
  loading,
  resendPasswordCode,
  resendCodeLoading,
  ...rest
}: UpdatePasswordFormProps) {
  const { t } = useTranslation();
  const confirmValidator = useConfirmPasswordValidator('newPassword');

  return (
    <Form {...rest} layout="vertical">
      <Form.Item
        name="code"
        label={t('CONFIRMATION_CODE_LABEL')}
        labelAlign="left"
        rules={[
          {
            required: true,
          },
        ]}
        hasFeedback
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="newPassword"
        label={t('NEW_PASSWORD_LABEL')}
        labelAlign="left"
        rules={[
          {
            required: true,
          },
        ]}
        hasFeedback
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        name="confirm"
        label={t('CONFIRM_PASSWORD_LABEL')}
        labelAlign="left"
        dependencies={['newPassword']}
        hasFeedback
        rules={[
          {
            required: true,
          },
          confirmValidator,
        ]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item style={{ textAlign: 'center' }}>
        <Button type="primary" loading={loading} disabled={resendCodeLoading} htmlType="submit" block>
          {t('SUBMIT_BUTTON')}
        </Button>
        <Button
          type="primary"
          loading={resendCodeLoading}
          disabled={loading}
          block
          style={{ marginTop: '10px' }}
          onClick={resendPasswordCode}
        >
          {t('RESEND_CODE')}
        </Button>
      </Form.Item>
    </Form>
  );
}
